var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25V9.75H0V2.25H3.75V1.5C3.75 1.39453 3.76953 1.29687 3.80859 1.20703C3.84766 1.11719 3.90039 1.03906 3.9668 0.972656C4.03711 0.902344 4.11719 0.847656 4.20703 0.808594C4.29688 0.769531 4.39453 0.75 4.5 0.75H7.5C7.60547 0.75 7.70312 0.769531 7.79297 0.808594C7.88281 0.847656 7.96094 0.902344 8.02734 0.972656C8.09766 1.03906 8.15234 1.11719 8.19141 1.20703C8.23047 1.29687 8.25 1.39453 8.25 1.5V2.25H12ZM4.5 2.25H7.5V1.5H4.5V2.25ZM0.75 3V4.08398L4.5 5.95312V5.25H7.5V5.95312L11.25 4.08398V3H0.75ZM5.25 6V6.75H6.75V6H5.25ZM11.25 9V4.91602L7.5 6.79688V7.5H4.5V6.79688L0.75 4.91602V9H11.25Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobicon);
export default __webpack_public_path__ + "static/media/jobicon.eeeba6e24daff98df9935f0b1d252b5f.svg";
export { ForwardRef as ReactComponent };